<script>
    import ConclusionModal from "./ConclusionModal";

    export default {
        components: {
            ConclusionModal
        },

        props: {
            costCenters: {
                type: Array,
                required: true,
            },
            costCarriers: {
                type: Array,
                required: true,
            },
        },

        methods: {
            showConclusionModal(travelExpenseReport, expenseReimbursement, attachments) {
                this.$modal.show(ConclusionModal, {
                    travelExpenseReport: travelExpenseReport,
                    expenseReimbursement: expenseReimbursement,
                    costCenters: this.costCenters,
                    costCarriers: this.costCarriers,
                    attachments: attachments,
                }, {height: 'auto', width: '66%'});
            }
        },

        mounted() {
            $(document).on('click', '.approve-report', function () {
                let clicked = $(this);
                let reportId = clicked.data('report-id');
                let type = clicked.data('type').trim();

                console.log(reportId);
                console.log(type);

                clicked.prop('disabled', true);
                clicked.find('span').hide();
                clicked.find('i.fa-spinner').show();
                clicked.find('i.fa-thumbs-up').hide();

                if (type == 'travel') {
                    axios
                        .post(`/travel-expense-report/${reportId}/approve`)
                        .then(response => {
                            clicked.parents('.report-row').removeClass('tw-bg-warning-secondary').addClass('tw-bg-success-secondary');
                            clicked.parents('.report-row').find('.delete-report, .edit-report').remove();
                            clicked.remove();
                            location.reload();
                        })
                        .catch(error => {
                            alert('Es trat ein unerwarteter Fehler auf!');
                        });
                } else if (type == 'expense') {
                    axios
                        .post(`/expense-reimbursement/${reportId}/approve`)
                        .then(response => {
                            clicked.parents('.report-row').removeClass('tw-bg-warning-secondary').addClass('tw-bg-success-secondary');
                            clicked.parents('.report-row').find('.delete-report, .edit-report').remove();
                            clicked.remove();
                            location.reload();
                        })
                        .catch(error => {
                            alert('Es trat ein unerwarteter Fehler auf!');
                        });
                }
            });
            $(document).on('click', '.btn-submit-deletion', function () {
                if ($('#comment').val()) {
                    $('#form-delete-request').submit();
                }
            });
        }
    }
</script>
